var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTakeawayGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 55,
    viewBox: "0 0 66 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.2178 50.5227H64.0003V28.9575H53.2178V50.5227Z",
    stroke: "#04ADAA",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2172 46.6483C24.913 56.083 34.3477 56.083 2 39.9092C4.86547 37.0437 7.12711 36.3698 10.0869 37.2135L21.724 40.8985",
    stroke: "#04ADAA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2178 31.6538H45.1308C38.7907 31.6538 34.3483 37.0451 33.0004 37.0451H23.5657C20.87 37.0451 20.87 42.4364 23.5657 42.4364H38.3917",
    stroke: "#04ADAA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.825 31.6521V2H10.0859V37.2132",
    stroke: "#04ADAA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8701 2V23.5652L28.957 16.9393L37.044 23.5652V2",
    stroke: "#04ADAA",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeawayGreen);
export default __webpack_public_path__ + "static/media/takeawayGreen.76e40b31c3c9b39ae19595b38bebc057.svg";
export { ForwardRef as ReactComponent };